import React from 'react';
import '../../../App.css';
import CardItem from '../../CardItem';
import Footer from '../../Footer';
import {
  centralHeatingPng,
  centralHeatingJpg,
  underfloorHeatingJpg,
} from '../../../images/assets';

export default function laptopCentralHeating() {
  return(
    <>
    <div style={{backgroundColor:'rgb(248, 248, 248)'}}>
      <div style={{marginLeft:'25%' ,width:'50%', padding:20, textAlign:'center', display: 'inherit', alignItems: 'center', justifyContent: 'center',}}>
            <CardItem
              src={centralHeatingPng}
              text='Central Heating'
              path='/central-heating'
            />
            </div>
    <div style={{width:'100%', padding:10, display: 'flex', flexDirection:'row'}}>
  
    <div >
            <div style={{padding:25 }}>
          <text style={{ fontSize:24}}>What is central heating system?</text>
          </div>
          <div style={{marginLeft:25, width:'80%', color:'rgb(50, 50, 50)'}}>
          <text style={{ fontSize:20}}>It's a system consist of a central boiler deliver hot water in pipes to the source of heating in the rooms,
           ther are two sources of heating which are aluminium radiator and underfloor heating.
           </text>
          </div>
          
          <div style={{marginTop:20, marginBottom:20}}>
          <text style={{ fontSize:20, marginLeft:25}}> The main components: </text>
          <div style={{marginLeft:25, width:'50%', color:'rgb(50, 50, 50)',fontSize:18 }}>
            <text>1- Boiler</text>
            </div>
            <div style={{marginLeft:25, width:'50%', color:'rgb(50, 50, 50)',fontSize:18 }}>
            <text>2- Piping network</text>
            </div>
            <div style={{marginLeft:25, width:'50%', color:'rgb(50, 50, 50)',fontSize:18 }}>
            <text>3- Heat Source (Radiator or Underfloor heating)</text>
              </div>
          </div>     
            </div>
            <div style={{marginLeft:200, width:'45%'}}>
            <CardItem
              src={centralHeatingJpg}
              text='Radiators'
              path='/central-heating'
            />
            </div>
            </div>
         
            <div style={{width:'100%', padding:10, display: 'flex', flexDirection:'row'}}>
    <div >
    <div style={{padding:25 }}>
          <text style={{ fontSize:24}}>What are the benefits of central heating?</text>
          </div>
          <div style={{marginLeft:25, width:800, color:'rgb(50, 50, 50)',fontSize:20, marginBottom:10 }}>
            <text>- Your home will be separated from the outside temperature and warm enough to feel summer all the year.</text>
            </div>
            <div style={{marginLeft:25, width:800, color:'rgb(50, 50, 50)',fontSize:20, marginBottom:20}}>
            <text>- Low running cost because the gas consumption is lower by 5 times than electrical consumption with long time guarantee. </text>
            </div>
             
            </div>
            <div style={{marginLeft:200, width:'50%'}}>
            <CardItem
              src={underfloorHeatingJpg}
              text='Underfloor'
              path='/central-heating'
            />
            </div>
            </div>

            <div style={{width:'90%', padding:10, display: 'flex', flexDirection:'row'}}>
   
           
            </div>
            <section id="contact">
      <Footer />
      </section>
            </div>
       
    </>
  )
}
